<ng-container>
  <div class="cx-store-finder-wrapper">
    <cx-store-finder-header></cx-store-finder-header>
    <router-outlet></router-outlet>
  </div>
</ng-container>
